// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jw-1";
export var messageSideRight = "_jw-2";
export var subscribeToBackInStockBubbleContainer = "_jw-0";